import FilterCard from "../FilterCard";

// Dispatches an assistant message's `interactive_prompt` to the right
// control. Currently that's just the filter card — every report/list tool
// routes through present_filter_card now, so this is the only shape the
// backend ever sends.
const InteractivePrompt = ({ prompt, onAnswer, disabled = false }) => {
  if (!prompt) return null;

  if (prompt.type === "filter_card") {
    return (
      <FilterCard prompt={prompt} onAnswer={onAnswer} disabled={disabled} />
    );
  }

  return null;
};

export default InteractivePrompt;
